import { mediaApi } from '~services/api/media';

export const useMediaPack = (opt: {
	userId: string;
	botId: string;
	messageId: string | number;
}) => {
	const {
		isLoading,
		data = [],
		isUninitialized,
		refetch,
	} = mediaApi.useGetMediaPackQuery(opt);

	return {
		isLoading,
		isUninitialized,
		data,
		refetch,
	};
};
